module.exports = __webpack_public_path__ + "img/menu-hopital-shriners.ed67b1d3.webp";